import React from 'react';

import { useTranslation, Trans } from 'react-i18next';

import { bemCssModules } from '@utils';

import style from './OperationsDisabledDisclaimer.scss';

const cn = bemCssModules(style, 'OperationsDisabledDisclaimer');

const OperationsDisabledDisclaimer: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(null, [className])}>
      <Trans i18nKey="operations.disabled">
        text
        <br />
        <a href="https://exchange.mercuryo.io" className={cn('link', ['link'])}>
          text
        </a>
      </Trans>
    </div>
  );
};

export default OperationsDisabledDisclaimer;
